export const scheduleLaterToday = "XMb";
export const scheduleThisEvening = "YMb";
export const scheduleTomorrow = "ZMb";
export const scheduleThisWeekend = "_Mb";
export const scheduleNextWeek = "$Mb";
export const scheduleChooseDate = "aNb";
export default {scheduleLaterToday,scheduleThisEvening,scheduleTomorrow,scheduleThisWeekend,scheduleNextWeek,scheduleChooseDate};